export default {
      id: "icon-external-link-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-external-link",
      toString: function () {
        return this.url;
      }
    }